
function getStyleTransformPrefix() {
	var style = 'transform';
	var vendors = ['webkit', 'Moz', 'O', 'ms'];
	var prefix = '';
	for (prefix in vendors) {
		if (typeof document.body.style[prefix + 'Transform'] !== 'undefined') {
			style = prefix + 'Transform';
		}
	}
	return style;
}

export default getStyleTransformPrefix;
